<template>
  <div class="naj-settings-box" :class="settingsBoxVisible ? 'show-me' : ''">
    <div class="naj-settings-container text-center">
      <div class="gear-icon" @click="settingsBoxVisible = !settingsBoxVisible">
        <Icon type="md-settings" />
      </div>
      <!-- <div class="naj-option-box">
        <h4>{{ local.settingsBox.systemColors }}</h4>
        <div class="naj-colors">
          <ul class="list-unstyled naj-controls">
            <li @click="toggleSettings({ color: 'green-sys' })"></li>
            <li @click="toggleSettings({ color: 'blue-sys' })"></li>
            <li @click="toggleSettings({ color: 'orange-sys' })"></li>
            <li @click="toggleSettings({ color: 'silver-sys' })"></li>
          </ul>
        </div>
      </div>-->
      <div class="naj-option-box">
        <h4>{{ local.settingsBox.fieldsSize }}</h4>
        <div class="naj-controls control-input">
          <naj-button
            :class="['control-element', { active: matchSettingClass('big-sys') }]"
            class="control-element"
            color="success"
            @click="toggleSettings({ size: 'big-sys' })"
          >
            {{ local.settingsBox.bigFields }}
          </naj-button>
          <naj-button
            :class="['control-element', { active: matchSettingClass('normal-sys') }]"
            color="success"
            @click="toggleSettings({ size: 'normal-sys' })"
          >
            {{ local.settingsBox.normalFields }}
          </naj-button>
        </div>
      </div>
      <!-- <div class="naj-option-box">
        <h4>{{ local.settingsBox.systemScheme }}</h4>
        <div class="naj-controls control-style">
          <naj-button
            :class="['control-element', { active: matchSettingClass('dark-sys') }]"
            color="success"
            @click="toggleSettings({ scheme: 'dark-sys' })"
          >{{ local.settingsBox.systemDark }}</naj-button>
          <naj-button
            :class="['control-element', { active: matchSettingClass('light-sys') }]"
            color="success"
            @click="toggleSettings({ scheme: 'light-sys' })"
          >{{ local.settingsBox.systemLight }}</naj-button>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('GlobalModule');

export default {
  computed: {
    ...mapState(['appSettings']),
    settingsClasses () {
      const settings = this.appSettings;
      return Object.keys(settings).reduce(
        (classes, optionKey) => `${classes} ${settings[optionKey] || ''}`,
        ''
      );
    },
  },
  data: function () {
    return {
      settingsBoxVisible: false,
    };
  },
  methods: {
    ...mapActions(['updateSettings']),
    toggleSettings (settings) {
      const payload = Object.assign({}, this.appSettings, settings);
      this.updateSettings(payload);
    },
    matchSettingClass (className) {
      return this.settingsClasses.match(className);
    },
  },
  name: 'naj-settings-box',
};
</script>

<style lang="scss" scoped>
.v-application .success {
  background-color: #00ad68 !important;
  border-color: #00ad68 !important;
}
::v-deep button span {
  color: #fff !important;
}
</style>
